import shuffle from 'lodash/shuffle'
import { useMemo } from 'react'

// import data from '../../games/justfont.json'
import useImages from '../useImages'

const useQuestions = (data) => {
  const keyed = useImages(`${data.path}`)
  const ans = {
    [data.left]: -1,
    [data.right]: 1,
  }
  const questions = useMemo(() => {
    const qs = data.choices.map((q, i) => ({
      id: i + 1,
      image: keyed[q.image],
      answer: ans[q.answer],
      label: q.question,
      explain: q.explain,
    }))
    return shuffle(qs)
  }, [])
  const results = useMemo(() => data.results.map(r => ({
    ...r,
    image: keyed[r.image],
  })), [keyed])
  return {
    questions,
    results,
  }
}

export default useQuestions
